// Tiny global bus so background music can pause while a video plays.
let count = 0;
const listeners = new Set();

const emit = () => listeners.forEach((cb) => cb(count > 0));

export const videoStarted = () => {
  count += 1;
  emit();
};

export const videoStopped = () => {
  count = Math.max(0, count - 1);
  emit();
};

export const onVideoActivity = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
